<template>
    <div class="wrapper">
        <div class="text-wrapper" ref="text-block" :style="style">
            <div v-html="content"></div>
        </div>
        <div class="text-center btn-toggle" v-if="overflown">
            <div @click="expanded = !expanded">
                <img v-if="expanded" src="/img/collapse.png" />
                <img v-else src="/img/expand.png" />
                <span>{{ expanded ? $t('general.collapse') : $t('general.expand')}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: { type: String, required: true },
        maxHeight: { type: Number, required: true },
    },
    computed: {
        style() {
            let height = this.overflown ? this.maxHeight : this.calculatedHeight;
            return {
                wordBreak: 'break-word',
                height: (this.expanded ? 'auto' : height + 'px'),
                overflowY: 'hidden',
                justifyContent: (this.overflown ? 'flex-start' : 'center')
            };
        },
        content() {
            var text = this.text;
            if (this.overflown && !this.expanded) {
                text = this.textFillMaxHeight();
            }

            return text.nl2brIfNotHTML();
        }
    },
    mounted() {
        this.checkTextOverflow();
    },
    data() {
        return {
            overflown: false,
            expanded: false,
            calculatedHeight: 0
        };
    },
    methods: {
        checkTextOverflow() {
            var $ele = $(this.$refs['text-block']).clone();
            if (!$(this.$refs['text-block']).css('width')) {
                return;
            }
            let css = {
                width: $(this.$refs['text-block']).css('width'),
                height: 'auto',
                maxHeight: 'none',
                position: 'absolute',
                visibility: 'hidden',
                wordBreak: 'break-word'
            };
            $ele.css(css);
            $ele.appendTo('body');
            this.calculatedHeight = parseInt($ele.css('height'));
            console.log(this.calculatedHeight);
            this.overflown = this.calculatedHeight > this.maxHeight;
            $ele.remove();
        },
        textFillMaxHeight() {
            var $ele = $(this.$refs['text-block']).clone();
            $ele.css({
                width: $(this.$refs['text-block']).css('width'),
                height: 'auto',
                maxHeight: 'none',
                position: 'absolute',
                visibility: 'hidden',
                wordBreak: 'break-word'
            });
            $ele.appendTo('body');

            var i = 1;
            var text = '';
            var step = 10;
            while(true) {
                var attempt = this.text.substring(0, step * i);
                $ele.text(attempt);
                let height = parseInt($ele.css('height'));
                if (height > this.maxHeight) {
                    text = text + '…';
                    break;
                }

                text = attempt;

                if (text.length === this.text.length) {
                    text = attempt;
                    break;
                }
                i++;
            }

            $ele.remove();
            return text;
        }
    }
}
</script>

<style scope>
    .text-wrapper {
        display: flex;
        flex-direction: column;
    }
    .text-block {
        overflow-y: hidden;
        padding-bottom: 32px;
    }

    .btn-toggle {
        cursor: pointer;
        width: 80px;
        border-radius: 8px;
        margin-left: auto;
        margin-right: auto;
        line-height: 32px;
        cursor: pointer;
        margin-bottom: 8px;
    }

    .btn-toggle img {
        width: 15px;
        height: 15px;
    }

    .btn-toggle:hover {
        background-color: rgba(0, 0, 0, 0.1);
        border-color: 1px solid #CCC;
    }
    .text-wrapper p {
        margin: 0;
    }
</style>
